import { AbstractControl, ValidationErrors } from '@angular/forms';

export function emailValidFormat(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;
  if (!value) return null;

  const atIndex = value.indexOf('@');
  if (atIndex === -1) return null;

  const localPart = value.substring(0, atIndex);

  if (localPart.startsWith('.') || localPart.endsWith('.') || localPart.includes('..')) {
    return { emailInvalid: true };
  }

  return null;
}

const COMMON_DOMAINS = [
  'gmail.com', 'googlemail.com',
  'hotmail.com', 'hotmail.com.br',
  'outlook.com', 'outlook.com.br',
  'yahoo.com', 'yahoo.com.br',
  'icloud.com', 'me.com',
  'live.com', 'live.com.br',
  'uol.com.br', 'bol.com.br', 'ig.com.br', 'terra.com.br',
  'protonmail.com', 'proton.me',
];

function levenshtein(a: string, b: string): number {
  const m = a.length;
  const n = b.length;
  const dp: number[][] = Array.from({ length: m + 1 }, (_, i) =>
    Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0)),
  );
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      dp[i][j] =
        a[i - 1] === b[j - 1]
          ? dp[i - 1][j - 1]
          : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
    }
  }
  return dp[m][n];
}

export type EmailDomainCheck =
  | { kind: 'suggestion'; domain: string }
  | { kind: 'unrecognized' }
  | null;

export function checkEmailDomain(email: string): EmailDomainCheck {
  if (!email?.includes('@')) return null;
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain || !domain.includes('.')) return null;
  if (COMMON_DOMAINS.includes(domain)) return null;

  let bestMatch = '';
  let bestDistance = Infinity;

  for (const known of COMMON_DOMAINS) {
    const dist = levenshtein(domain, known);
    if (dist < bestDistance) {
      bestDistance = dist;
      bestMatch = known;
    }
  }

  if (bestDistance <= 2) {
    return { kind: 'suggestion', domain: bestMatch };
  }

  return { kind: 'unrecognized' };
}
